"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = exports.generateLocalizedStrings = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../utils/index.js");
require("@itwin/itwinui-css/css/date-picker.css");
const index_js_2 = require("../Buttons/IconButton/index.js");
const index_js_3 = require("../TimePicker/index.js");
const isSameDay = (a, b) => {
    return (a &&
        b &&
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate());
};
const isInDateRange = (date, startDate, endDate) => {
    if (!date || !startDate || !endDate) {
        return false;
    }
    const minDate = new Date(startDate);
    const maxDate = new Date(endDate);
    const testDate = new Date(date);
    testDate && testDate.setHours(0, 0, 0, 0);
    minDate && minDate.setHours(0, 0, 0, 0);
    maxDate && maxDate.setHours(0, 0, 0, 0);
    return testDate > minDate && testDate < maxDate;
};
// Type guard for multiple did not work
const isSingleOnChange = (onChange, enableRangeSelect) => {
    return !enableRangeSelect;
};
const defaultMonths = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
const defaultShortDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const defaultLongDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];
/**
 * Generate localized months and days strings using `Intl.DateTimeFormat` for passed locale to use in DatePicker component.
 * If locale is not passed, browser locale will be used.
 */
const generateLocalizedStrings = (locale) => {
    const shortWeekDayFormatter = new Intl.DateTimeFormat(locale, {
        weekday: 'short',
    });
    const longWeekDayFormatter = new Intl.DateTimeFormat(locale, {
        weekday: 'long',
    });
    const monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
    const months = [
        monthFormatter.format(new Date(2020, 0, 1)),
        monthFormatter.format(new Date(2020, 1, 1)),
        monthFormatter.format(new Date(2020, 2, 1)),
        monthFormatter.format(new Date(2020, 3, 1)),
        monthFormatter.format(new Date(2020, 4, 1)),
        monthFormatter.format(new Date(2020, 5, 1)),
        monthFormatter.format(new Date(2020, 6, 1)),
        monthFormatter.format(new Date(2020, 7, 1)),
        monthFormatter.format(new Date(2020, 8, 1)),
        monthFormatter.format(new Date(2020, 9, 1)),
        monthFormatter.format(new Date(2020, 10, 1)),
        monthFormatter.format(new Date(2020, 11, 1)),
    ];
    const days = [
        longWeekDayFormatter.format(new Date(2020, 10, 1)),
        longWeekDayFormatter.format(new Date(2020, 10, 2)),
        longWeekDayFormatter.format(new Date(2020, 10, 3)),
        longWeekDayFormatter.format(new Date(2020, 10, 4)),
        longWeekDayFormatter.format(new Date(2020, 10, 5)),
        longWeekDayFormatter.format(new Date(2020, 10, 6)),
        longWeekDayFormatter.format(new Date(2020, 10, 7)),
    ];
    const shortDays = [
        shortWeekDayFormatter.format(new Date(2020, 10, 1)).slice(0, 2),
        shortWeekDayFormatter.format(new Date(2020, 10, 2)).slice(0, 2),
        shortWeekDayFormatter.format(new Date(2020, 10, 3)).slice(0, 2),
        shortWeekDayFormatter.format(new Date(2020, 10, 4)).slice(0, 2),
        shortWeekDayFormatter.format(new Date(2020, 10, 5)).slice(0, 2),
        shortWeekDayFormatter.format(new Date(2020, 10, 6)).slice(0, 2),
        shortWeekDayFormatter.format(new Date(2020, 10, 7)).slice(0, 2),
    ];
    return {
        months,
        shortDays,
        days,
    };
};
exports.generateLocalizedStrings = generateLocalizedStrings;
/**
 * Date picker component
 * @example
 * <DatePicker date={new Date()} onChange={(e) => console.log('New date value: ' + e)} />
 */
const DatePicker = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { date, onChange, localizedNames, className, style, setFocus = false, showTime = false, use12Hours = false, precision, hourStep, minuteStep, secondStep, useCombinedRenderer, combinedRenderer, hourRenderer, minuteRenderer, secondRenderer, meridiemRenderer, showYearSelection = false, enableRangeSelect = false, startDate, endDate, isDateDisabled, ...rest } = props;
    (0, index_js_1.useTheme)();
    const monthNames = (_a = localizedNames === null || localizedNames === void 0 ? void 0 : localizedNames.months) !== null && _a !== void 0 ? _a : defaultMonths;
    const shortDays = (_b = localizedNames === null || localizedNames === void 0 ? void 0 : localizedNames.shortDays) !== null && _b !== void 0 ? _b : defaultShortDays;
    const longDays = (_c = localizedNames === null || localizedNames === void 0 ? void 0 : localizedNames.days) !== null && _c !== void 0 ? _c : defaultLongDays;
    const [selectedDay, setSelectedDay] = React.useState(date);
    const [selectedStartDay, setSelectedStartDay] = React.useState(startDate);
    const [selectedEndDay, setSelectedEndDay] = React.useState(endDate);
    const [focusedDay, setFocusedDay] = React.useState((_d = selectedStartDay !== null && selectedStartDay !== void 0 ? selectedStartDay : selectedDay) !== null && _d !== void 0 ? _d : new Date());
    const [displayedMonthIndex, setDisplayedMonthIndex] = React.useState((_f = (_e = selectedStartDay === null || selectedStartDay === void 0 ? void 0 : selectedStartDay.getMonth()) !== null && _e !== void 0 ? _e : selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.getMonth()) !== null && _f !== void 0 ? _f : new Date().getMonth());
    const [displayedYear, setDisplayedYear] = React.useState((_h = (_g = selectedStartDay === null || selectedStartDay === void 0 ? void 0 : selectedStartDay.getFullYear()) !== null && _g !== void 0 ? _g : selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.getFullYear()) !== null && _h !== void 0 ? _h : new Date().getFullYear());
    // boolean that toggles between the user picking the start date and end date for date range
    const [isSelectingStartDate, setIsSelectingStartDate] = React.useState(true);
    // Used to focus days only when days are changed
    // e.g. without this, when changing months day would be focused
    const needFocus = React.useRef(setFocus);
    React.useEffect(() => {
        if (needFocus.current) {
            needFocus.current = false;
        }
    });
    const setMonthAndYear = React.useCallback((newMonth, newYear) => {
        setDisplayedMonthIndex(newMonth);
        setDisplayedYear(newYear);
    }, []);
    React.useEffect(() => {
        var _a, _b, _c, _d;
        const currentDate = new Date();
        setSelectedDay(date);
        setSelectedStartDay(startDate);
        setSelectedEndDay(endDate);
        if (!enableRangeSelect) {
            setFocusedDay(date !== null && date !== void 0 ? date : currentDate);
        }
        setMonthAndYear((_b = (_a = startDate === null || startDate === void 0 ? void 0 : startDate.getMonth()) !== null && _a !== void 0 ? _a : date === null || date === void 0 ? void 0 : date.getMonth()) !== null && _b !== void 0 ? _b : currentDate.getMonth(), (_d = (_c = startDate === null || startDate === void 0 ? void 0 : startDate.getFullYear()) !== null && _c !== void 0 ? _c : date === null || date === void 0 ? void 0 : date.getFullYear()) !== null && _d !== void 0 ? _d : currentDate.getFullYear());
    }, [date, setMonthAndYear, startDate, endDate, enableRangeSelect]);
    const days = React.useMemo(() => {
        let offsetToFirst = new Date(displayedYear, displayedMonthIndex, 1).getDay();
        // if its sunday, show one week before
        if (0 === offsetToFirst) {
            offsetToFirst = 7;
        }
        const daysInMonth = [];
        // generate 6 weeks of dates
        for (let i = 1; i <= 42; i++) {
            const adjustedDay = i - offsetToFirst;
            daysInMonth.push(new Date(displayedYear, displayedMonthIndex, adjustedDay));
        }
        return daysInMonth;
    }, [displayedMonthIndex, displayedYear]);
    const weeks = React.useMemo(() => {
        const weeksInMonth = [];
        const weekCount = Math.ceil(days.length / 7);
        for (let i = 0; i < weekCount; i++) {
            weeksInMonth.push(days.slice(i * 7, (i + 1) * 7));
        }
        return weeksInMonth;
    }, [days]);
    const getNewFocusedDate = (newYear, newMonth) => {
        var _a;
        const currentDate = (_a = selectedStartDay !== null && selectedStartDay !== void 0 ? selectedStartDay : selectedDay) !== null && _a !== void 0 ? _a : new Date();
        const newDate = new Date(newYear, newMonth, currentDate.getDate(), currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds());
        return newDate;
    };
    const handleMoveToPreviousYear = () => {
        const newYear = displayedYear - 1;
        setMonthAndYear(displayedMonthIndex, newYear);
        setFocusedDay(getNewFocusedDate(newYear, displayedMonthIndex));
    };
    const handleMoveToNextYear = () => {
        const newYear = displayedYear + 1;
        setMonthAndYear(displayedMonthIndex, newYear);
        setFocusedDay(getNewFocusedDate(newYear, displayedMonthIndex));
    };
    const handleMoveToPreviousMonth = () => {
        const newMonth = displayedMonthIndex !== 0 ? displayedMonthIndex - 1 : 11;
        const newYear = displayedMonthIndex !== 0 ? displayedYear : displayedYear - 1;
        setMonthAndYear(newMonth, newYear);
        setFocusedDay(getNewFocusedDate(newYear, newMonth));
    };
    const handleMoveToNextMonth = () => {
        const newMonth = displayedMonthIndex !== 11 ? displayedMonthIndex + 1 : 0;
        const newYear = displayedMonthIndex !== 11 ? displayedYear : displayedYear + 1;
        setMonthAndYear(newMonth, newYear);
        setFocusedDay(getNewFocusedDate(newYear, newMonth));
    };
    const onDayClick = (day) => {
        // single date selection
        if (!enableRangeSelect) {
            if (day.getMonth() !== (selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.getMonth())) {
                setMonthAndYear(day.getMonth(), day.getFullYear());
            }
            const currentDate = selectedDay !== null && selectedDay !== void 0 ? selectedDay : new Date();
            const newDate = new Date(day.getFullYear(), day.getMonth(), day.getDate(), currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds());
            setSelectedDay(newDate);
            setFocusedDay(newDate);
            isSingleOnChange(onChange, enableRangeSelect) && (onChange === null || onChange === void 0 ? void 0 : onChange(newDate));
        }
        // start date selection (date range only)
        else if (isSelectingStartDate) {
            if (day.getMonth() !== (selectedStartDay === null || selectedStartDay === void 0 ? void 0 : selectedStartDay.getMonth())) {
                setMonthAndYear(day.getMonth(), day.getFullYear());
            }
            const currentStartDate = selectedStartDay !== null && selectedStartDay !== void 0 ? selectedStartDay : new Date();
            const newStartDate = new Date(day.getFullYear(), day.getMonth(), day.getDate(), currentStartDate.getHours(), currentStartDate.getMinutes(), currentStartDate.getSeconds());
            setSelectedStartDay(newStartDate);
            setFocusedDay(newStartDate);
            // if the start date is after the end date or the end date is undefined, reset the end date
            if (!(0, index_js_1.isBefore)(newStartDate, selectedEndDay)) {
                setSelectedEndDay(newStartDate);
                onChange === null || onChange === void 0 ? void 0 : onChange(newStartDate, newStartDate);
            }
            else {
                selectedEndDay && (onChange === null || onChange === void 0 ? void 0 : onChange(newStartDate, selectedEndDay));
            }
            setIsSelectingStartDate(false);
        }
        // end date selection (date range only)
        else {
            if (day.getMonth() !== (selectedEndDay === null || selectedEndDay === void 0 ? void 0 : selectedEndDay.getMonth())) {
                setMonthAndYear(day.getMonth(), day.getFullYear());
            }
            const currentEndDate = selectedEndDay !== null && selectedEndDay !== void 0 ? selectedEndDay : new Date();
            const newEndDate = new Date(day.getFullYear(), day.getMonth(), day.getDate(), currentEndDate.getHours(), currentEndDate.getMinutes(), currentEndDate.getSeconds());
            setFocusedDay(newEndDate);
            // if the end date is before the start date, move back the start date and still have user select end date
            if (!(0, index_js_1.isBefore)(newEndDate, selectedStartDay)) {
                setSelectedEndDay(newEndDate);
                selectedStartDay && (onChange === null || onChange === void 0 ? void 0 : onChange(selectedStartDay, newEndDate));
                setIsSelectingStartDate(true);
            }
            else {
                setSelectedStartDay(newEndDate);
                selectedEndDay && (onChange === null || onChange === void 0 ? void 0 : onChange(newEndDate, selectedEndDay));
            }
        }
    };
    const isPreviousMonthDisabled = isDateDisabled === null || isDateDisabled === void 0 ? void 0 : isDateDisabled(new Date(displayedYear, displayedMonthIndex, 0));
    const isNextMonthDisabled = isDateDisabled === null || isDateDisabled === void 0 ? void 0 : isDateDisabled(new Date(displayedYear, displayedMonthIndex + 1, 1));
    const isPreviousYearDisabled = isDateDisabled === null || isDateDisabled === void 0 ? void 0 : isDateDisabled(new Date(displayedYear - 1, 11, 31));
    const isNextYearDisabled = isDateDisabled === null || isDateDisabled === void 0 ? void 0 : isDateDisabled(new Date(displayedYear + 1, 0, 1));
    const handleCalendarKeyDown = (event) => {
        if (event.altKey) {
            return;
        }
        if (!focusedDay) {
            return;
        }
        const adjustedFocusedDay = new Date(focusedDay);
        switch (event.key) {
            case 'ArrowDown':
                adjustedFocusedDay.setDate(focusedDay.getDate() + 7);
                if (adjustedFocusedDay.getMonth() !== displayedMonthIndex) {
                    if (isNextMonthDisabled) {
                        return;
                    }
                    handleMoveToNextMonth();
                }
                setFocusedDay(adjustedFocusedDay);
                needFocus.current = true;
                event.preventDefault();
                break;
            case 'ArrowUp':
                adjustedFocusedDay.setDate(focusedDay.getDate() - 7);
                if (adjustedFocusedDay.getMonth() !== displayedMonthIndex) {
                    if (isPreviousMonthDisabled) {
                        return;
                    }
                    handleMoveToPreviousMonth();
                }
                setFocusedDay(adjustedFocusedDay);
                needFocus.current = true;
                event.preventDefault();
                break;
            case 'ArrowLeft':
                adjustedFocusedDay.setDate(focusedDay.getDate() - 1);
                if (adjustedFocusedDay.getMonth() !== displayedMonthIndex) {
                    if (isPreviousMonthDisabled) {
                        return;
                    }
                    handleMoveToPreviousMonth();
                }
                setFocusedDay(adjustedFocusedDay);
                needFocus.current = true;
                event.preventDefault();
                break;
            case 'ArrowRight':
                adjustedFocusedDay.setDate(focusedDay.getDate() + 1);
                if (adjustedFocusedDay.getMonth() !== displayedMonthIndex) {
                    if (isNextMonthDisabled) {
                        return;
                    }
                    handleMoveToNextMonth();
                }
                setFocusedDay(adjustedFocusedDay);
                needFocus.current = true;
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
            case 'Spacebar':
                if (!(isDateDisabled === null || isDateDisabled === void 0 ? void 0 : isDateDisabled(focusedDay))) {
                    onDayClick(focusedDay);
                }
                event.preventDefault();
                break;
        }
    };
    const getDayClass = (day) => {
        if (day.getMonth() !== displayedMonthIndex) {
            return 'iui-calendar-day-outside-month';
        }
        let dayClass = 'iui-calendar-day';
        const isSelectedDay = isSameDay(day, selectedDay) ||
            (isSameDay(day, selectedStartDay) && isSameDay(day, selectedEndDay));
        if (isSelectedDay) {
            dayClass += '-selected';
        }
        else if (isSameDay(day, selectedStartDay)) {
            dayClass += '-range-start';
        }
        else if (isSameDay(day, selectedEndDay)) {
            dayClass += '-range-end';
        }
        // adds range class to dates between start and end date
        if (selectedStartDay &&
            selectedEndDay &&
            isInDateRange(day, selectedStartDay, selectedEndDay)) {
            dayClass += '-range';
        }
        if (isSameDay(day, new Date())) {
            dayClass += '-today';
        }
        return dayClass;
    };
    return (React.createElement("div", { className: (0, classnames_1.default)('iui-date-picker', className), style: style, ...rest },
        React.createElement("div", null,
            React.createElement("div", { className: 'iui-calendar-month-year' },
                showYearSelection && (React.createElement(index_js_2.IconButton, { styleType: 'borderless', onClick: handleMoveToPreviousYear, "aria-label": 'Previous year', size: 'small', disabled: isPreviousYearDisabled },
                    React.createElement(index_js_1.SvgChevronLeftDouble, null))),
                React.createElement(index_js_2.IconButton, { styleType: 'borderless', onClick: handleMoveToPreviousMonth, "aria-label": 'Previous month', size: 'small', disabled: isPreviousMonthDisabled },
                    React.createElement(index_js_1.SvgChevronLeft, null)),
                React.createElement("span", { "aria-live": 'polite' },
                    React.createElement("span", { className: 'iui-calendar-month', title: monthNames[displayedMonthIndex] }, monthNames[displayedMonthIndex]),
                    "\u00A0",
                    displayedYear),
                React.createElement(index_js_2.IconButton, { styleType: 'borderless', onClick: handleMoveToNextMonth, "aria-label": 'Next month', size: 'small', disabled: isNextMonthDisabled },
                    React.createElement(index_js_1.SvgChevronRight, null)),
                showYearSelection && (React.createElement(index_js_2.IconButton, { styleType: 'borderless', onClick: handleMoveToNextYear, "aria-label": 'Next year', size: 'small', disabled: isNextYearDisabled },
                    React.createElement(index_js_1.SvgChevronRightDouble, null)))),
            React.createElement("div", { className: 'iui-calendar-weekdays' }, shortDays.map((day, index) => (React.createElement("div", { key: day, title: longDays[index] }, day)))),
            React.createElement("div", { onKeyDown: handleCalendarKeyDown, role: 'listbox' }, weeks.map((weekDays, weekIndex) => {
                return (React.createElement("div", { key: `week-${displayedMonthIndex}-${weekIndex}`, className: 'iui-calendar-week' }, weekDays.map((weekDay, dayIndex) => {
                    const dateValue = weekDay.getDate();
                    const isDisabled = isDateDisabled === null || isDateDisabled === void 0 ? void 0 : isDateDisabled(weekDay);
                    return (React.createElement("div", { key: `day-${displayedMonthIndex}-${dayIndex}`, className: getDayClass(weekDay), onClick: () => !isDisabled && onDayClick(weekDay), role: 'option', tabIndex: isSameDay(weekDay, focusedDay) ? 0 : -1, "aria-disabled": isDisabled ? 'true' : undefined, ref: (element) => isSameDay(weekDay, focusedDay) &&
                            needFocus.current &&
                            (element === null || element === void 0 ? void 0 : element.focus()) }, dateValue));
                })));
            }))),
        showTime && (React.createElement(index_js_3.TimePicker, { date: selectedStartDay !== null && selectedStartDay !== void 0 ? selectedStartDay : selectedDay, use12Hours: use12Hours, precision: precision, hourStep: hourStep, minuteStep: minuteStep, secondStep: secondStep, useCombinedRenderer: useCombinedRenderer, combinedRenderer: combinedRenderer, hourRenderer: hourRenderer, minuteRenderer: minuteRenderer, secondRenderer: secondRenderer, meridiemRenderer: meridiemRenderer, onChange: (date) => {
                var _a, _b, _c, _d, _e, _f;
                return isSingleOnChange(onChange, enableRangeSelect)
                    ? onChange === null || onChange === void 0 ? void 0 : onChange(date)
                    : onChange === null || onChange === void 0 ? void 0 : onChange(new Date((_a = selectedStartDay === null || selectedStartDay === void 0 ? void 0 : selectedStartDay.getFullYear()) !== null && _a !== void 0 ? _a : date.getFullYear(), (_b = selectedStartDay === null || selectedStartDay === void 0 ? void 0 : selectedStartDay.getMonth()) !== null && _b !== void 0 ? _b : date.getMonth(), (_c = selectedStartDay === null || selectedStartDay === void 0 ? void 0 : selectedStartDay.getDate()) !== null && _c !== void 0 ? _c : date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()), new Date((_d = selectedEndDay === null || selectedEndDay === void 0 ? void 0 : selectedEndDay.getFullYear()) !== null && _d !== void 0 ? _d : date.getFullYear(), (_e = selectedEndDay === null || selectedEndDay === void 0 ? void 0 : selectedEndDay.getMonth()) !== null && _e !== void 0 ? _e : date.getMonth(), (_f = selectedEndDay === null || selectedEndDay === void 0 ? void 0 : selectedEndDay.getDate()) !== null && _f !== void 0 ? _f : date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
            } }))));
};
exports.DatePicker = DatePicker;
exports.default = exports.DatePicker;
